import { render } from "./MembersAddressView.vue?vue&type=template&id=3caf4971"
import script from "./MembersAddressView.vue?vue&type=script&lang=js"
export * from "./MembersAddressView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\luke\\Desktop\\membership_application\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__